import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { UserAuth } from './context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user } = UserAuth();
  const location = useLocation();

  if (!user) {
    if (location.pathname === '/checkout' && location.state) {
      sessionStorage.setItem('pendingCheckoutData', JSON.stringify(location.state));
      return <Navigate to='/signup/checkout' />;
    }
    return <Navigate to='/signup/aurora' />;
  }

 {/*if (!user.emailVerified) {
    return <Navigate to='/verify' />;
  }*/}

  return children;
}

export default ProtectedRoute;
